import { RootState } from "@/app/stores"
import { deleteSavedDocument, getSavedDocuments, ISavedDocument } from "@/shared/api/aviabooking"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchSavedDocuments = createAsyncThunk<
    ISavedDocument[],
    void,
    { state: RootState }
>('aviabooking/fetchSavedDocuments', async (_, thunkAPI) => {
    try {
        const response = await getSavedDocuments()
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const deleteSavedDocumentThunk = createAsyncThunk<
    string,
    string,
    { state: RootState }
>('aviabooking/deleteSavedDocument', async (documentId, thunkAPI) => {
    try {
        await deleteSavedDocument(documentId)
        return documentId
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})
